import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { GenericService } from "../../../../../_services/generic-service";


@Injectable()
export class PulsanteService extends GenericService {
    constructor(http: HttpClient) {
        super(http, "PulsanteAF");
    }


}


// WEBPACK FOOTER //
// ./src/app/theme/pages/default/cybersecurity/_service/PulsanteService.ts